import React, { useEffect, useState } from "react";
import TableCardView from "../../../../library/custom/tableCardView/tableCardView";
import TableCard from "../../../../library/custom/tableCard/tableCard";
import Grid from "@mui/material/Grid";
import { TableLoader } from "../../../../library/common/Loader";
import NORow from "../../../../library/custom/noRow/noRow";
import { LOGIN_ORG_ID, ORG_ID, USER_ID } from "../../../../constant/constant";
import FilterCommonStatusSelect from "../../../admin/shared/FilterCommonStatusSelect";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import * as lmsAction from "../../../../redux/actions/lmsAction";
import { useDispatch } from "react-redux";
import { useDebounce } from "../../../../utils/useDebounceSearch";
import TabPanel from "../tabPanel/tabPanel";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

const LmsMarketPlace = ({
  coursesUserList,
  handleViewOnClick,
  isLoading,
  viewUnEnrollOnClick,
  getCoursesUserListData,
  categoryUserListData,
  getategoryListData,
  isProfile = false,
  isSafetyLog = false,
  usersId,
  coursesUserListDatas,
  searchParams,
}) => {
  const [page, setPage] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedValue, setSelectedValue] = useState();
  const [selectActive, setSelectActive] = useState();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);

  const [activeInActive, setActiveInActive] = useState({
    ACTIVE: false,
    INACTIVE: false,
  });
  const [isTableLoading, setisTableLoading] = useState(false);

  const PAGE_SIZE = 6;
  const open1 = Boolean(anchorEl);
  const id = open1 ? "simple-popover" : undefined;
  const [value, setValue] = useState(0);
  const isFirstRender = React.useRef(true);

  const handleActiveInActiveChange = (event) => {
    setSelectActive(event.target.value);
    const { value } = event.target;
    setActiveInActive((prevState) => {
      if (!prevState) return { ACTIVE: false, INACTIVE: false };
      const newState = {
        ...prevState,
        [value]: !prevState[value],
      };
      let status = "";
      if (newState.ACTIVE && !newState.INACTIVE) {
        status = true;
      } else if (!newState.ACTIVE && newState.INACTIVE) {
        status = false;
      }
      if (!newState.ACTIVE && !newState.INACTIVE) {
        dispatch(lmsAction.clearCategoryList());
      } else {
        const data = {
          pageNumber: 1,
          isGlobal: "",
          status: status,
        };
        getategoryListData(data);
      }

      return newState;
    });
  };

  const columns = [
    {
      field: "courseId",
      width: "fit-content",
      cellClassName: "customCellTable custom",
      renderCell: (cellValues) => {
        const { id: courseIDS } = cellValues;
        const courseId = courseIDS.split("|")?.[0];
        const status = cellValues?.row?.status;
        const statusId = cellValues?.row?.statusId;
        return (
          <>
            <TableCard
              viewOnClick={() => handleViewOnClick(courseId, status, statusId)}
              rowData={cellValues?.row}
              viewEnrollOnClick={() =>
                viewUnEnrollOnClick(courseId, status, statusId)
              }
            />
          </>
        );
      },
    },
  ];
  const handlePagignation = (newPage) => {
    setPage(newPage);
    getCoursesUserListData({
      pageNumber: newPage + 1,
      pageSize: PAGE_SIZE,
      search: debouncedSearch,
      catIds: "",
      statusId: value === 0 ? 2 : value === 2 ? "" : 1,
      userId: isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
      orgId: ORG_ID(),
      isSendMail: false,
      isScorm: true,
    });
  };
  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };
  const handleSearch = () => {
    setAnchorEl(null);
    const data = {
      pageNumber: 1,
      pageSize: PAGE_SIZE,
      search: debouncedSearch,
      catIds: selectedValue ? selectedValue : "",
      statusId: value === 0 ? 2 : value === 2 ? "" : 1,
      userId: parseInt(USER_ID()),
      orgId: parseInt(ORG_ID()),
      organisationId: ORG_ID(),
      status: 2,
      isActive: selectActive,
      isScorm: true,
    };
    getCoursesUserListData(data);
  };
  const handleClear = () => {
    setSelectedValue("");
    setSearch("");
    setPage(0);
    getCoursesUserListData({
      pageNumber: 1,
      pageSize: PAGE_SIZE,
      search: "",
      catIds: "",
      statusId: value === 0 ? 2 : value === 2 ? "" : 1,
      userId: isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
      orgId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      isSendMail: false,
      isScorm: true,
    });
    setAnchorEl(null);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };
  const onChangeCategoryType = (item) => {
    setSelectedValue(item?.target?.value);
  };

  const handleautoSearch = (event) => {
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (debouncedSearch === undefined) return;

    if (
      coursesUserListDatas?.filterObj &&
      String(debouncedSearch || "") ===
        String(coursesUserListDatas.filterObj.search || "")
    ) {
      return;
    }

    const data = {
      pageNumber: 1,
      pageSize: PAGE_SIZE,
      search: debouncedSearch,
      catIds: selectedValue ? selectedValue : "",
      statusId: value === 0 ? 2 : value === 2 ? "" : 1,
      userId: isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
      orgId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      isSendMail: false,
      isScorm: true,
    };
    getCoursesUserListData(data);
  }, [debouncedSearch]);

  const handleChange = (event, newValue) => {
    setSelectedValue();
    setSearch("");
    setValue(newValue);
    const ApicallDirect = !isSafetyLog || (isSafetyLog && usersId);

    if (!ApicallDirect) return;
    getCoursesUserListData({
      pageNumber: 1,
      pageSize: PAGE_SIZE,
      search: search ? search : "",
      catIds: selectedValue ? selectedValue : "",
      statusId: newValue === 0 ? 2 : newValue === 2 ? "" : 1,
      userId: isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
      orgId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      isSendMail: false,
      isScorm: true,
    });
  };
  useEffect(() => {
    if (coursesUserListDatas?.filterObj) {
      const f = coursesUserListDatas.filterObj;
      setSearch(f.search || "");
      setSelectedValue(f.catIds || "");
      setPage((f.pageNumber || 1) - 1);
      const savedStatus = f.isActive;
      if (savedStatus === "ACTIVE") {
        setActiveInActive({ ACTIVE: true, INACTIVE: false });
      } else if (savedStatus === "INACTIVE") {
        setActiveInActive({ ACTIVE: false, INACTIVE: true });
      } else {
        setActiveInActive({ ACTIVE: false, INACTIVE: false });
      }
      getategoryListData({
        pageNumber: 1,
        isGlobal: "",
        isActive: savedStatus || "",
      });
    }
  }, [coursesUserListDatas?.filterObj]);

  const noRecourdCount = coursesUserList?.noOfRecords;
  useEffect(() => {
    const courseId = searchParams?.get("courseid");
    if (courseId) {
      setValue(1);
      getCoursesUserListData({
        pageNumber: 1,
        pageSize: PAGE_SIZE,
        search: search ? search : "",
        catIds: selectedValue ? selectedValue : "",
        statusId: 1,
        userId:
          isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
        orgId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
        isSendMail: false,
        isScorm: true,
      });
    }
  }, [searchParams]);

  return (
    <div className="lessonsList noIn">
      <Grid container className="tabuserlmstab">
        <Grid lg={7} xs={12}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              className="tabcustom"
              icon={
                value === 0 ? (
                  <div className="totalV">
                    {value === 0 ? noRecourdCount : ""}
                  </div>
                ) : (
                  ""
                )
              }
              iconPosition="end"
              label="Assigned"
            />

            <Tab
              className="tabcustom"
              icon={
                value === 1 ? (
                  <div className="totalV">
                    {value === 1 ? noRecourdCount : ""}
                  </div>
                ) : (
                  ""
                )
              }
              iconPosition="end"
              label="Completed"
            />
          </Tabs>
        </Grid>
        {!isSafetyLog && (
          <Grid lg={5} xs={12} mt={1}>
            <div className="filtertoolbox">
              <div className="filter_of_caselisttoolBox">
                <div className="searchcaseid">
                  <label htmlFor="search">
                    <span>
                      <SearchIcon />
                    </span>
                    <div>
                      <input
                        id="search"
                        placeholder="Search"
                        type="text"
                        value={search}
                        className=""
                        onChange={handleautoSearch}
                        autoComplete="off"
                      />
                    </div>
                  </label>
                </div>

                <div className="filter_btn">
                  <button
                    aria-describedby={id}
                    variant="contained"
                    type="button"
                    name="btn"
                    onClick={(e) => handleClick(e)}
                  >
                    <FilterListIcon id="icn" /> Filters
                  </button>
                  <FilterCommonStatusSelect
                    id={id}
                    open={open1}
                    anchorEl={anchorEl}
                    handleClose={handleClose}
                    handleApply={handleSearch}
                    handleClear={handleClear}
                    filterSelect
                    categoryType={categoryUserListData?.categoryList ?? []}
                    categoryOnChanges={onChangeCategoryType}
                    category={selectedValue}
                    filterStatus={false}
                    resetBtn={true}
                    label={"Category"}
                    activeInActive={activeInActive}
                    setActiveInActive={setActiveInActive}
                    handleActiveInActiveChange={handleActiveInActiveChange}
                    statusCheckbox={true}
                  />
                </div>
              </div>
            </div>
          </Grid>
        )}
      </Grid>
      <Grid container>
        <TabPanel className="tabPanel" value={value} index={0}>
          {" "}
          {!isTableLoading && (
            <TableCardView
              columns={columns}
              rows={coursesUserList?.courses ?? []}
              rowCount={coursesUserList?.noOfRecords ?? 0}
              loading={isLoading}
              components={{
                LoadingOverlay: TableLoader,
                NoRowsOverlay: NORow,
              }}
              rowsPerPageOptions={[10]}
              page={page}
              pagination
              pageSize={PAGE_SIZE}
              onPageChange={handlePagignation}
            />
          )}
        </TabPanel>
        <TabPanel className="tabPanel" value={value} index={1}>
          {!isTableLoading && (
            <TableCardView
              columns={columns}
              rows={coursesUserList?.courses ?? []}
              rowCount={coursesUserList?.noOfRecords ?? 0}
              loading={isLoading}
              components={{
                LoadingOverlay: TableLoader,
                NoRowsOverlay: NORow,
              }}
              rowsPerPageOptions={[10]}
              page={page}
              pagination
              pageSize={PAGE_SIZE}
              onPageChange={handlePagignation}
            />
          )}
        </TabPanel>
      </Grid>
    </div>
  );
};

export default LmsMarketPlace;
